export const EditDialogModeEnum = {
  Add: 'Add',
  Edit: 'Edit',
};
